// ==========================================================================
// custom.js — カスタムスクリプト
// このファイルにプロジェクト固有の JavaScript を追記してください。
// defer 属性付きで読み込まれるため、DOM 構築完了後に実行されます。
// ==========================================================================

// ==========================================
// スクロールアニメーション（Intersection Observer）
// ==========================================

(function () {
  function initFadeUp() {
    const targets = document.querySelectorAll('.js-fade-up');
    if (!targets.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target); // 一度発火したら監視終了
          }
        });
      },
      { threshold: 0.4 } // 要素の40%が見えたら発火
    );

    targets.forEach((el) => observer.observe(el));
  }

  // 通常ページ読み込み時
  initFadeUp();

  // Shopifyテーマエディタでセクションが追加・更新された時にも対応
  document.addEventListener('shopify:section:load', initFadeUp);
})();
